/* ScarZens PDP behaviour.
   Extracted verbatim from sections/main-product.liquid, where these four IIFEs
   were inlined into every product page response. None contained Liquid, so they
   were ~31KB of static JS re-sent on every PDP view and never browser-cached.
   Concatenated in original document order; the loader stays a plain (non-defer)
   <script> at the position of the first block so execution order relative to
   scarzens.js is unchanged. */

/* ---- 1/4: gallery, buy box, variant + sticky bar (was lines 1289-1725) ---- */
(function () {
  'use strict';

  function initFzPdp(scope) {
    var roots = (scope || document).querySelectorAll('[data-fzpd]');
    Array.prototype.forEach.call(roots, function (root) {
      if (root.getAttribute('data-fzpd-bound') === '1') return;
      root.setAttribute('data-fzpd-bound', '1');

      var slot     = root.querySelector('[data-pdp-mediaslot]');
      var thumbs   = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-thumb]'));
      var dots     = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-dot]'));
      var cards    = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-variant]'));
      var select   = root.querySelector('[data-pdp-select]');
      var qty      = root.querySelector('[data-pdp-qty]');
      var buy      = root.querySelector('[data-pdp-buy]');
      var add      = root.querySelector('[data-pdp-add]');
      var planInput = root.querySelector('[data-pdp-planinput]');
      var priceEl  = root.querySelector('[data-pdp-price]');
      var cmpEl    = root.querySelector('[data-pdp-compare]');
      var saveEl   = root.querySelector('[data-pdp-save]');
      var sticky   = root.querySelector('[data-pdp-sticky]');
      var stickyP  = root.querySelector('[data-pdp-stickyprice]');
      var stickyB  = root.querySelector('[data-pdp-stickybuy]');
      var form     = root.querySelector('form[action*="/cart/add"]');
      var cartRoot = (window.FZ && window.FZ.routes && window.FZ.routes.cart) || '/cart';

      /* ---------- quantity ---------- */
      function getQty() {
        var n = qty ? parseInt(qty.value, 10) : 1;
        return (!n || n < 1) ? 1 : n;
      }
      function setQty(n) {
        if (!qty) return;
        qty.value = n < 1 ? 1 : n;
        syncBuyHref();
      }
      var minus = root.querySelector('[data-qty-minus]');
      var plus  = root.querySelector('[data-qty-plus]');
      if (minus) minus.addEventListener('click', function () { setQty(getQty() - 1); });
      if (plus)  plus.addEventListener('click', function () { setQty(getQty() + 1); });
      if (qty)   qty.addEventListener('change', function () { setQty(getQty()); });

      function syncBuyHref() {
        if (!buy) return;
        var vid = buy.getAttribute('data-pdp-buyvariant');
        if (!vid) return;
        var plan = buy.getAttribute('data-pdp-buyplan');
        /* Buy Now → straight to checkout; /cart/add carries selling_plan (the :qty permalink can't) */
        buy.setAttribute('href', cartRoot + '/add?id=' + vid + '&quantity=' + getQty()
          + (plan ? '&selling_plan=' + plan : '') + '&return_to=/checkout');
      }

      /* ---------- add to cart ----------------------------------------------
         The button is a real submit, so with no JS the browser posts the form
         and lands on /cart. Here we intercept it into the drawer instead, and
         only if FZCart is actually present: a missing drawer must fall back to
         the native post, not swallow the click. */
      var addLabelEl = add && add.querySelector('[data-pdp-addlabel]');
      var addLabelText = addLabelEl ? addLabelEl.textContent : '';
      var addResetTimer = null;

      function resetAddLabel() {
        if (!add || !addLabelEl) return;
        if (addResetTimer) { clearTimeout(addResetTimer); addResetTimer = null; }
        add.classList.remove('is-added');
        add.removeAttribute('disabled');
        addLabelEl.textContent = addLabelText;
      }

      if (add) {
        add.addEventListener('click', function (e) {
          if (!window.FZCart) return;              /* let the form post natively */
          e.preventDefault();
          var vid = add.getAttribute('data-pdp-addvariant');
          if (!vid) return;
          var plan = add.getAttribute('data-pdp-addplan') || null;
          add.setAttribute('disabled', 'disabled');
          if (addLabelEl) addLabelEl.textContent = 'Adding…';
          Promise.resolve(window.FZCart.add(vid, getQty(), plan))
            .then(function () {
              add.classList.add('is-added');
              if (addLabelEl) addLabelEl.textContent = 'Added to cart';
            })
            .catch(function () {})
            .then(function () {
              add.removeAttribute('disabled');
              addResetTimer = setTimeout(resetAddLabel, 2200);
            });
        });
      }

      /* ---------- media gallery ---------- */
      function activate(index) {
        var thumb = thumbs[index];
        if (!thumb || !slot) return;
        var tpl = thumb.querySelector('template');
        if (tpl) {
          var frag = tpl.content.cloneNode(true);
          /* Quality follows the device, decided BEFORE the fragment hits the DOM — the
             browser commits to the first source at insert, so this is the only moment a
             script can still choose. Markup leads with the derived 720p (near-1080 sharp
             on this stage, ~40% lighter than the 7.2Mbps original); phones step that
             leading source down to 480p so mobile data and weak links never starve. */
          if (window.matchMedia && window.matchMedia('(max-width: 900px)').matches) {
            /* All sources, not only derived ones: a clip whose ladder tops at 720p (no 1080p,
               so no derived source) must still step down to 480p on a phone. */
            frag.querySelectorAll('source').forEach(function (s) {
              s.setAttribute('src', (s.getAttribute('src') || '')
                .replace('HD-720p-4.5Mbps', 'SD-480p-1.5Mbps')
                .replace('HD-720p-1.6Mbps', 'SD-480p-0.9Mbps'));
            });
          }
          slot.innerHTML = '';
          slot.appendChild(frag);

          /* Start the clip HERE — synchronously, still inside the tap's call stack.
             iOS Safari only honours load()/play() on a preload="none" element while the
             user-gesture token is live; the deferred bind/playVisible pass (setTimeout 80)
             runs after that token has expired, so on iPhone the clip silently refused to
             load while desktop, which allows muted autoplay freely, looked perfect. This
             is also why the description videos were unaffected: they are autoplay+muted
             already in the DOM and never needed a gesture. */
          var gv = slot.querySelector('video');
          if (gv) {
            gv.muted = true; gv.defaultMuted = true; gv.playsInline = true;
            gv.setAttribute('playsinline', ''); gv.setAttribute('webkit-playsinline', '');
            gv.preload = 'auto';
            try { gv.load(); } catch (e) {}
            var gp = gv.play();
            if (gp && gp.catch) gp.catch(function () {});
          }
        }
        thumbs.forEach(function (t, i) { t.setAttribute('data-active', i === index ? '1' : '0'); });
        dots.forEach(function (d, i) { d.setAttribute('data-active', i === index ? '1' : '0'); });
      }
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { activate(i); }); });
      dots.forEach(function (d, i) { d.addEventListener('click', function () { activate(i); }); });

      /* ---------- arrows + swipe --------------------------------------------
         Both funnel into activate(), which starts a video synchronously inside the
         event's call stack — that is what iOS requires, and a tap on an arrow or the
         end of a swipe are both genuine user gestures, so video playback keeps working
         exactly as it does from a thumbnail. Order follows the thumbnails, so it matches
         what the dots and rail already show. */
      function currentIndex() {
        for (var i = 0; i < thumbs.length; i++) {
          if (thumbs[i].getAttribute('data-active') === '1') return i;
        }
        return 0;
      }
      function step(delta) {
        var n = thumbs.length;
        if (n < 2) return;
        var next = currentIndex() + delta;

        /* The interactive Zen sits after the last photo.
           It is deliberately not one of `thumbs` - the gallery indexes those
           against product.media and an extra entry would shift every index -
           so it is handled here instead: arrow past either end and it opens,
           rather than wrapping straight back round the photos. */
        if (next >= n || next < 0) {
          var zen = document.querySelector('.zen3d-tile[data-zen-open]');
          var panel = document.querySelector('[data-zen-panel]');
          if (zen && (!panel || panel.hidden)) { zen.click(); return; }
        }
        activate((next + n) % n);
      }
      var prevBtn = root.querySelector('[data-pdp-prev]');
      var nextBtn = root.querySelector('[data-pdp-next]');
      if (prevBtn) prevBtn.addEventListener('click', function (e) { e.preventDefault(); step(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function (e) { e.preventDefault(); step(1); });

      /* Swipe. Deliberately passive and decided only on touchend: never preventDefault
         on touchmove, or vertical page scrolling would fight the gallery. A swipe counts
         only when it travels >45px AND is clearly more horizontal than vertical, so a
         diagonal scroll never flips the media. */
      if (slot && thumbs.length > 1) {
        var sx = 0, sy = 0, tracking = false;
        slot.addEventListener('touchstart', function (e) {
          if (e.touches.length !== 1) { tracking = false; return; }
          tracking = true; sx = e.touches[0].clientX; sy = e.touches[0].clientY;
        }, { passive: true });
        slot.addEventListener('touchend', function (e) {
          if (!tracking) return;
          tracking = false;
          var t = e.changedTouches && e.changedTouches[0];
          if (!t) return;
          var dx = t.clientX - sx, dy = t.clientY - sy;
          if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy) * 1.4) return;
          step(dx < 0 ? 1 : -1);        /* drag left = next, matching native carousels */
        }, { passive: true });
      }

      /* Keyboard parity for desktop and assistive tech. */
      if (slot) {
        var stageEl = root.querySelector('[data-pdp-stage]');
        if (stageEl) {
          stageEl.addEventListener('keydown', function (e) {
            if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
            else if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
          });
        }
      }

      /* ---------- warm gallery video clips (kill the "hitch then play") ---------
         A gallery clip lives in an inert <template> and only starts downloading when
         its thumb is clicked — so the first play waits on the network. On intent (hover
         or press, both fire before the click resolves) we prime the EXACT source the
         player will use: the tiny HLS playlist for Safari/iOS, plus the first ~2MB of the
         same MP4 rendition FZVideo's bestSource picks (720p desktop / smallest mobile) for
         everyone else. Capped so we never pull a whole heavy file, and network-only — no
         extra <video>/decoder, so the iOS media budget is untouched. Playback then starts
         from cache almost immediately instead of from a cold download. */
      var FZ_WARM_MOBILE = !!(window.matchMedia && window.matchMedia('(max-width: 900px)').matches);
      function fzPickMp4(urls) {
        if (!urls.length) return '';
        var s = urls.map(function (u) {
          var mb = /(\d+(?:\.\d+)?)Mbps/i.exec(u), hp = /(\d+)p/i.exec(u);
          return { u: u, rate: mb ? parseFloat(mb[1]) : 99, h: hp ? parseInt(hp[1], 10) : 0 };
        });
        if (FZ_WARM_MOBILE) { s.sort(function (a, b) { return a.rate - b.rate; }); return s[0].u; }
        var byH = s.slice().sort(function (a, b) { return a.h - b.h; });
        var ex = byH.filter(function (x) { return x.h === 720; })[0];
        if (ex) return ex.u;
        var cap = byH.filter(function (x) { return x.h && x.h <= 720; });
        return cap.length ? cap[cap.length - 1].u : byH[0].u;
      }
      var fzWarmedHls = {}, fzWarmedMp4 = {};
      /* MEASURED DEAD END — kept as a no-op so callers stay simple. A ranged fetch()
         is NOT reused by a <video> element: warming 2048KB then letting the player
         request the file produced a full 3150KB re-download (5.2MB total for one clip
         on mobile data) with no improvement in time-to-first-frame. Speculative byte
         warming is therefore off; the real win was starting load()/play() inside the
         tap gesture, which is what actually fixed iOS. */
      function fzWarmThumb() { return; }
      function fzWarmThumbDisabled(thumb, mp4Too, userIntent) {
        /* Phones stay at zero speculative bytes on page load — but a real tap is not
           speculation. pointerdown fires before the click resolves, so warming there
           gives the clip a head start without reintroducing background downloads.
           Hover-driven and idle warms remain desktop-only (touch has no hover anyway). */
        if (!userIntent && window.matchMedia && window.matchMedia('(max-width: 900px)').matches) return;
        if (!thumb || (thumb.getAttribute('data-media-type') || '') !== 'video') return;
        var id = thumb.getAttribute('data-media-id') || thumb.getAttribute('data-index') || '';
        var tpl = thumb.querySelector('template');
        if (!tpl) return;
        var mp4 = [], hls = '';
        Array.prototype.forEach.call(tpl.content.querySelectorAll('source[src]'), function (sc) {
          var u = sc.getAttribute('src') || ''; if (!u) return;
          if (/\.m3u8(\?|$)/i.test(u) || /mpegurl/i.test(sc.getAttribute('type') || '')) { if (!hls) hls = u; }
          else mp4.push(u);
        });
        var prime = function (url, capped) {
          if (!url) return;
          try {
            /* Videos are same-origin (scarzens.com/cdn/…), so a normal request keeps the Range
               header: the CDN answers 206 with exactly the first ~2MB, which the <video> then
               reuses from cache — a real head start, not just a warmed socket. credentials:
               'same-origin' matches how the media element fetches so the cache entry is shared.
               The 3s abort is only a backstop against a stray 200 (full-file) response. */
            var opts = { credentials: 'same-origin' };
            if (capped) {
              opts.headers = { 'Range': 'bytes=0-2097151' };
              if ('AbortController' in window) {
                var ac = new AbortController();
                opts.signal = ac.signal;
                setTimeout(function () { try { ac.abort(); } catch (e) {} }, 3000);
              }
            }
            fetch(url, opts).catch(function () {});
          } catch (e) {}
        };
        /* Mirror FZVideo's delivery policy exactly, or we warm a file the player never
           uses. Safari/iOS streams the HLS ladder, so the playlist alone is all it needs
           and pulling an mp4 there is wasted mobile data. Everyone else plays the derived
           LIGHT encode (480p/720p), which is what must be warmed — not the 1080p that
           Liquid happens to expose. */
        var FZV = window.FZVideo || {};
        /* Warm what the player will ACTUALLY load. Sources are emitted MP4-first now
           (an MP4 reaches its first frame in one round trip; HLS needs three), so every
           engine — Safari and iOS included — plays the light MP4. Branching on native
           HLS support here meant iPhones warmed only the tiny .m3u8 playlist, a file
           they never open, which is why the tap still hitched after the gesture fix. */
        if (hls && !FZV.nativeHls && !fzWarmedHls[id]) { fzWarmedHls[id] = 1; prime(hls, false); }
        if (mp4Too && !fzWarmedMp4[id]) {
          fzWarmedMp4[id] = 1;
          var picked = fzPickMp4(mp4);
          prime((FZV.lighter && FZV.lighter(picked)) || picked, true);
        }
      }
      thumbs.forEach(function (t) {
        t.addEventListener('pointerenter', function () { fzWarmThumb(t, true, false); });
        t.addEventListener('pointerdown', function () { fzWarmThumb(t, true, true); });   /* real tap: warm on every device */
      });
      /* Prime the first video thumb proactively once idle — the most likely first play. */
      (function () {
        var fv = null, i;
        for (i = 0; i < thumbs.length; i++) { if ((thumbs[i].getAttribute('data-media-type') || '') === 'video') { fv = thumbs[i]; break; } }
        if (!fv) return;
        /* Held until the page has finished loading, so it never competes with the
           critical path — that is what made phones slow before. But pointerdown only
           buys ~30ms of lead, which is not enough for a first frame, so the FIRST
           gallery clip (by far the most likely tap) gets its opening bytes primed once
           the page is idle. One clip, range-capped, after load, on a connection that
           is otherwise finished: this is what makes the first tap play immediately
           instead of starting a cold download. Data-saver / 2G still opt out inside
           prime(), and every other thumb still warms only on real intent. */
        var go = function () {
          var run = function () { fzWarmThumb(fv, true, true); };
          if ('requestIdleCallback' in window) requestIdleCallback(run, { timeout: 2500 }); else setTimeout(run, 400);
        };
        if (document.readyState === 'complete') go();
        else window.addEventListener('load', go, { once: true });
      })();

      function showMediaById(id) {
        if (!id) return;
        for (var i = 0; i < thumbs.length; i++) {
          if (thumbs[i].getAttribute('data-media-id') === String(id)) { activate(i); return; }
        }
      }

      /* ---------- external video (delegated so it survives media swaps) ---------- */
      if (slot) {
        slot.addEventListener('click', function (e) {
          var btn = e.target.closest ? e.target.closest('[data-pdp-extplay]') : null;
          if (!btn) return;
          e.preventDefault();
          var wrap = btn.closest('.fzpd-ext');
          if (!wrap) return;
          var id = wrap.getAttribute('data-video-id');
          var type = wrap.getAttribute('data-video-type');
          var src = type === 'vimeo'
            ? 'https://player.vimeo.com/video/' + id + '?autoplay=1&muted=1'
            : 'https://www.youtube.com/embed/' + id + '?autoplay=1&controls=0&modestbranding=1&rel=0&showinfo=0';
          var frame = document.createElement('iframe');
          frame.setAttribute('src', src);
          frame.setAttribute('frameborder', '0');
          frame.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
          frame.setAttribute('allowfullscreen', 'allowfullscreen');
          wrap.innerHTML = '';
          wrap.appendChild(frame);
        });
      }

      /* ---------- variants ---------- */
      function selectVariant(card) {
        if (!card || card.disabled) return;
        cards.forEach(function (c) { c.setAttribute('data-active', c === card ? '1' : '0'); });

        var id   = card.getAttribute('data-variant-id');
        var pr   = card.getAttribute('data-price');
        var cmp  = card.getAttribute('data-compare');
        var sav  = card.getAttribute('data-save');
        var plan = card.getAttribute('data-plan');

        if (priceEl && pr) priceEl.textContent = pr;
        if (stickyP && pr) stickyP.textContent = pr;
        if (cmpEl) { cmpEl.textContent = cmp || ''; cmpEl.style.display = cmp ? '' : 'none'; }
        if (saveEl) { saveEl.textContent = sav || ''; saveEl.style.display = sav ? '' : 'none'; }

        if (buy) {
          buy.setAttribute('data-pdp-buyvariant', id);
          if (plan) buy.setAttribute('data-pdp-buyplan', plan);
          else buy.removeAttribute('data-pdp-buyplan');
        }
        if (add) {
          add.setAttribute('data-pdp-addvariant', id);
          if (plan) add.setAttribute('data-pdp-addplan', plan);
          else add.removeAttribute('data-pdp-addplan');
          resetAddLabel();
        }
        /* keep the form's selling_plan in sync so the dynamic checkout button and
           native submit follow the variant (disabled = one-time, no plan sent) */
        if (planInput) {
          if (plan) { planInput.value = plan; planInput.disabled = false; }
          else { planInput.value = ''; planInput.disabled = true; }
        }
        if (select) {
          select.value = id;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
        syncBuyHref();
        showMediaById(card.getAttribute('data-media'));

        if (window.history && window.history.replaceState) {
          try {
            var u = new URL(window.location.href);
            u.searchParams.set('variant', id);
            window.history.replaceState({}, '', u.toString());
          } catch (err) {}
        }
      }
      cards.forEach(function (c) { c.addEventListener('click', function () { selectVariant(c); }); });

      /* ---------- sticky bar ---------- */
      if (sticky && buy) {
        if (stickyB) {
          stickyB.addEventListener('click', function (e) {
            e.preventDefault();
            /* Mirror the source: the sticky bar is labelled with buy_text, so it
               drives the Buy Now permalink. Falls back to add-to-cart when the
               Buy Now link is absent (variant unavailable). */
            if (buy) { syncBuyHref(); buy.click(); }
          });
        }
        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (en) {
              sticky.setAttribute('data-show', en.isIntersecting ? '0' : '1');
            });
          /* -12%, not -60%. The old margin only counted the buttons as visible
             in the top 40% of the screen, which was fine when they sat far down
             the page. Now that the buy box clears the fold on mobile, that made
             the sticky bar appear directly beneath a Buy Now button that was
             already on screen — two identical CTAs stacked. A small margin means
             the sticky only takes over once the real CTA is genuinely leaving. */
          }, { rootMargin: '0px 0px -12% 0px' });
          io.observe(root.querySelector('.fzpd-paybtns') || buy);
        } else {
          sticky.setAttribute('data-show', '1');
        }
      }

      syncBuyHref();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initFzPdp(); });
  } else {
    initFzPdp();
  }
  document.addEventListener('shopify:section:load', function (e) { initFzPdp(e.target); });
})();

/* ---- 2/4: rating popover (was lines 1728-1764) ---- */
(function () {
  /* Rating popover. Click to open (not hover): on touch there is no hover, and
     a hover-only disclosure would be unreachable on the device where the buy
     box matters most. */
  function bind(root) {
    (root || document).querySelectorAll('[data-fz-rt]').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      var pop = btn.parentElement.querySelector('[data-fz-rtpop]');
      if (!pop) return;
      var set = function (open) {
        pop.hidden = !open;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      };
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        set(pop.hidden);
      });
      document.addEventListener('click', function (e) {
        if (!pop.hidden && !btn.contains(e.target) && !pop.contains(e.target)) set(false);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !pop.hidden) { set(false); btn.focus(); }
      });
      /* The footer link is an in-page jump; close on the way out so the popover
         is not left hanging over the page after the scroll. */
      pop.addEventListener('click', function (e) {
        if (e.target.closest('a')) set(false);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { bind(); });
  else bind();
  document.addEventListener('shopify:section:load', function (e) { bind(e.target); });
})();

/* ---- 3/4: product-video overlay (was lines 1900-1973) ---- */
(function () {
  /* Product-video overlay: bind the stage spinner + bottom progress bar to whichever
     <video> is the active gallery media, and re-bind when the media is swapped. */
  function initVfx(root) {
    (root && root.querySelectorAll ? root : document).querySelectorAll('[data-pdp-stage]').forEach(function (stage) {
      if (stage.dataset.vfxBound === '1') return;
      stage.dataset.vfxBound = '1';
      var vfx  = stage.querySelector('[data-pdp-vfx]');
      var bar  = stage.querySelector('[data-pdp-vbar]');
      var slot = stage.querySelector('[data-pdp-mediaslot]');
      if (!vfx || !bar || !slot) return;
      var current = null;

      /* Reveal the spinner only if buffering actually persists (~220ms), so a quick
         load never flashes it — that flash is itself read as a hitch. Hiding is instant. */
      var bufTimer = null;
      function buffering(on) {
        if (on) {
          if (vfx.classList.contains('is-buffering') || bufTimer) return;
          bufTimer = setTimeout(function () { bufTimer = null; vfx.classList.add('is-buffering'); }, 220);
        } else {
          if (bufTimer) { clearTimeout(bufTimer); bufTimer = null; }
          vfx.classList.remove('is-buffering');
        }
      }
      function progress() {
        if (!current || !current.duration || isNaN(current.duration)) return;
        vfx.classList.add('has-progress');
        bar.style.width = Math.max(0, Math.min(100, (current.currentTime / current.duration) * 100)) + '%';
        if (current.readyState >= 3) buffering(false);
      }
      /* Poster crossfade: hold the still over the loading clip, then fade it out the
         instant the video can play — poster → motion, no hard pop. */
      var poster = vfx.querySelector('[data-pdp-vposter]');
      function reveal() { vfx.classList.remove('is-loading'); }
      var onWait = function () { buffering(true); };
      var onGo   = function () { buffering(false); reveal(); };

      function detach(v) {
        if (!v) return;
        v.removeEventListener('timeupdate', progress); v.removeEventListener('waiting', onWait);
        v.removeEventListener('stalled', onWait); v.removeEventListener('loadstart', onWait);
        v.removeEventListener('playing', onGo); v.removeEventListener('canplay', onGo);
      }
      function attach(v) {
        current = v;
        if (poster) {
          var ps = v.getAttribute('poster');
          poster.style.backgroundImage = ps ? 'url("' + ps + '")' : '';
          if (ps && v.readyState < 3) vfx.classList.add('is-loading'); else vfx.classList.remove('is-loading');
        }
        v.addEventListener('timeupdate', progress); v.addEventListener('waiting', onWait);
        v.addEventListener('stalled', onWait); v.addEventListener('loadstart', onWait);
        v.addEventListener('playing', onGo); v.addEventListener('canplay', onGo);
        buffering(v.readyState < 3); progress();
        if (v.readyState >= 3) reveal();
      }
      function sync() {
        var v = slot.querySelector('video');
        if (v === current) return;
        detach(current); bar.style.width = '0'; vfx.classList.remove('has-progress'); vfx.classList.remove('is-loading');
        if (v) { vfx.hidden = false; attach(v); } else { vfx.hidden = true; buffering(false); current = null; }
      }

      sync();
      if ('MutationObserver' in window) { new MutationObserver(sync).observe(slot, { childList: true, subtree: true }); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initVfx(document); });
  else initVfx(document);
  document.addEventListener('shopify:section:load', function (e) { initVfx(e.target); });
})();

/* ---- 4/4: on-screen gallery video autoplay (was lines 2493-2544) ----
   Gallery/stage video autoplays when it's ON SCREEN — muted, so browsers allow it —
   on every device (same IntersectionObserver pattern the gameplay videos use). Only
   the visible clip plays: switching thumbnails pauses the old one and plays the new,
   so at most one clip loads at a time. That preserves the original "don't download
   every clip on load" intent (they stay preload="none") while giving real autoplay. */
(function () {
  function playSafe(v){ var p = v.play(); if (p && p.catch) p.catch(function(){}); }
  function hydrate(scope){ if (window.FZVideo && window.FZVideo.hydrateVisible) { try { window.FZVideo.hydrateVisible(scope); } catch (e) {} } }

  function playVisible(scope){
    hydrate(scope);
    scope.querySelectorAll('.fzpd-media video').forEach(function (v) {
      if (v.offsetParent !== null && !v.hidden) {
        v.muted = true; v.playsInline = true;
        if (v.preload !== 'auto') v.preload = 'auto';
        playSafe(v);
      } else { try { v.pause(); } catch (e) {} }
    });
  }

  function bind(root){
    var scope = (root && root.querySelectorAll) ? root : document;
    scope.querySelectorAll('.fzpd-media video').forEach(function (v) {
      if (v.getAttribute('data-fzpd-vbound') === '1') return;
      v.setAttribute('data-fzpd-vbound', '1');
      v.muted = true; v.defaultMuted = true; v.playsInline = true; v.loop = true;
      /* once its data is in, play it if it's on screen */
      v.addEventListener('loadeddata', function () { if (v.offsetParent !== null) playSafe(v); });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting && en.target.offsetParent !== null) {
              hydrate(en.target.closest('.fzpd-media') || document);
              if (en.target.preload !== 'auto') en.target.preload = 'auto';
              playSafe(en.target);
            } else if (!en.target.paused) { try { en.target.pause(); } catch (e) {} }
          });
        }, { threshold: 0.25 }).observe(v);
      }
    });
    playVisible(scope);
  }

  function boot(root){
    bind(root);
    (root && root.querySelectorAll ? root : document).querySelectorAll('.fzpd-thumb').forEach(function (t) {
      if (t.dataset.vbound) return;
      t.dataset.vbound = '1';
      t.addEventListener('click', function () { setTimeout(function () { bind(document); playVisible(document); }, 80); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();